import React from "react";
import { CpImage } from "@/components/company/CpImage";
import { iconFor } from "@/lib/companyProfile";
import { CtaButton } from "@/components/company/CompanyHero";

export function SectionHeading({ eyebrow, title, id, align = "left" }) {
  if (!title && !eyebrow) return null;
  return (
    <div className={`storefront-section-heading ${align === "center" ? "text-center" : ""}`}>
      {eyebrow ? <div className="cp-eyebrow">{eyebrow}</div> : null}
      {title ? <h2 id={id} className="storefront-section-title">{title}</h2> : null}
    </div>
  );
}

export function AboutSection({ data }) {
  if (!data) return null;
  return (
    <section id="tentang" className="storefront-section cp-anchor" data-testid="company-about" aria-labelledby="cp-about-title">
      <div className={`cp-about ${data.image ? "cp-about--with-image" : ""}`}>
        <div className="cp-about-copy">
          <SectionHeading eyebrow="Tentang Kami" title={data.title} id="cp-about-title" />
          {data.description ? <p className="cp-prose" data-testid="company-about-desc">{data.description}</p> : null}
        </div>
        {data.image ? <CpImage slot="about" src={data.image} alt={data.title || "Tentang kami"} className="cp-about-media" testId="company-about-image" /> : null}
      </div>
    </section>
  );
}

export function WhyUsSection({ data }) {
  if (!data?.items?.length) return null;
  return (
    <section id="keunggulan" className="storefront-section cp-anchor" data-testid="company-why-us" aria-labelledby="cp-why-title">
      <SectionHeading eyebrow="Keunggulan" title={data.title} id="cp-why-title" />
      <div className="cp-why-grid">
        {data.items.map((it, i) => {
          const Icon = iconFor(it.icon);
          return (
            <article key={`${it.title}-${i}`} className="cp-why-card" data-testid={`company-why-item-${i}`}>
              <span className="cp-why-icon"><Icon size={20} aria-hidden="true" /></span>
              <h3 className="cp-why-title">{it.title}</h3>
              {it.description ? <p className="cp-why-desc">{it.description}</p> : null}
            </article>
          );
        })}
      </div>
    </section>
  );
}

export function StatsSection({ data }) {
  if (!data?.items?.length) return null;
  return (
    <section className="storefront-section" data-testid="company-stats" aria-label={data.title || "Statistik"}>
      <SectionHeading title={data.title} id="cp-stats-title" />
      <dl className="cp-stats">
        {data.items.map((it, i) => (
          <div key={`${it.label}-${i}`} className="cp-stat" data-testid={`company-stat-${i}`}>
            <dd className="cp-stat-value">{it.value}</dd>
            <dt className="cp-stat-label">{it.label}</dt>
          </div>
        ))}
      </dl>
    </section>
  );
}

export function BusinessCtaSection({ data }) {
  if (!data?.cta_url || !data?.cta_label) return null;
  return (
    <section className="storefront-section" data-testid="company-business-cta" aria-labelledby="cp-biz-title">
      <div className="cp-biz">
        <div className="min-w-0 max-w-2xl">
          <div className="cp-eyebrow cp-eyebrow--on-primary">Bisnis & Grosir</div>
          {data.title ? <h2 id="cp-biz-title" className="cp-biz-title">{data.title}</h2> : null}
          {data.description ? <p className="cp-biz-desc">{data.description}</p> : null}
        </div>
        <div className="shrink-0"><CtaButton cta={{ label: data.cta_label, url: data.cta_url }} variant="on-primary" testId="company-business-cta-button" /></div>
      </div>
    </section>
  );
}
